<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzFtyCheckTaskStatus === 'N'
              ? 'primary'
              : row.amzFtyCheckTaskStatus === 'Y'
              ? 'success'
              : row.amzFtyCheckTaskStatus === 'P'
              ? 'warning'
              : 'danger'
          "
        >
          {{ row.v_amzFtyCheckTaskStatus }}
        </el-tag>
      </template>

      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-view"
                :command="{
                  pageType: 'detail',
                  amzFtyCheckTaskCode: row.amzFtyCheckTaskCode,
                  amzFtyCheckTaskNo: row.amzFtyCheckTaskNo,
                }"
              >
                {{ $l('INDEX.btn_view_details') || '查看详情' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-edit"
                divided
                :command="{
                  pageType: 'edit',
                  amzFtyCheckTaskCode: row.amzFtyCheckTaskCode,
                  amzFtyCheckTaskNo: row.amzFtyCheckTaskNo,
                }"
                :disabled="!allow('M') || row.amzFtyCheckTaskStatus != 'N'"
              >
                {{ $l('btn_edit') || '编辑任务' }}
              </el-dropdown-item>

              <el-dropdown-item
                icon="el-icon-delete"
                :command="{
                  pageType: 'del',
                  amzFtyCheckTaskCode: row.amzFtyCheckTaskCode,
                }"
                :disabled="!allow('D') || row.amzFtyCheckTaskStatus != 'N'"
              >
                {{ $l('btn_del') || '删除任务' }}
              </el-dropdown-item>

              <el-dropdown-item
                divided
                icon="el-icon-video-play"
                :command="{
                  pageType: 'startCounting',
                  amzFtyCheckTaskCode: row.amzFtyCheckTaskCode,
                  amzFtyCheckTaskNo: row.amzFtyCheckTaskNo,
                }"
                :disabled="!allow('E') || row.amzFtyCheckTaskStatus != 'N'"
              >
                {{ $l('btn_start_counting') || '开始盘点' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-edit-outline"
                :command="{
                  pageType: 'reviseCounting',
                  amzFtyCheckTaskCode: row.amzFtyCheckTaskCode,
                  amzFtyCheckTaskNo: row.amzFtyCheckTaskNo,
                }"
                :disabled="!allow('F') || row.amzFtyCheckTaskStatus != 'P'"
              >
                {{ $l('btn_revise_counting') || '修改实盘' }}
              </el-dropdown-item>

              <el-dropdown-item
                icon="el-icon-check"
                :command="{
                  pageType: 'update',
                  amzFtyCheckTaskCode: row.amzFtyCheckTaskCode,
                  amzFtyCheckTaskNo: row.amzFtyCheckTaskNo,
                }"
                :disabled="!allow('C') || row.amzFtyCheckTaskStatus != 'P'"
              >
                {{ $l('btn_update') || '数据调整' }}
              </el-dropdown-item>
              <el-dropdown-item
                divided
                icon="el-icon-video-pause"
                :command="{
                  pageType: 'stopCounting',
                  amzFtyCheckTaskCode: row.amzFtyCheckTaskCode,
                  amzFtyCheckTaskNo: row.amzFtyCheckTaskNo,
                }"
                :disabled="!allow('S') || row.amzFtyCheckTaskStatus != 'P'"
              >
                {{ $l('btn_stop_counting') || '盘点终止' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    handleCommand(command) {
      const { pageType, amzFtyCheckTaskCode, amzFtyCheckTaskNo } = command

      switch (pageType) {
        case 'detail':
        case 'edit':
        case 'stopCounting':
        case 'startCounting':
        case 'update':
        case 'reviseCounting':
          this.$emit('openEditPage', {
            pageType: pageType,
            params: { code: amzFtyCheckTaskCode },
            query: { amzFtyCheckTaskNo: amzFtyCheckTaskNo },
          })
          break
        case 'del':
          this.del(amzFtyCheckTaskCode)
          break
        default:
          return
      }
    },
    del(amzFtyCheckTaskCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .ecomAmzFtyCheckTaskDelApi({ amzFtyCheckTaskCode })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
  },
}
</script>
